<script lang="ts">
  import { formatCentsAsUsd, parseDollarsToCents } from "../../util/money"

  export let name: string
  export let value: number | undefined = undefined
  export let id: string | undefined = undefined
  export let disabled: boolean = false
  export let dataRole: string | undefined = undefined

  let className = ""
  export { className as class }

  let textValue = value !== undefined ? formatCentsAsUsd(value) : ""

  function setValue() {
    value = parseDollarsToCents(textValue)
  }

  function formatValue() {
    if (value !== undefined) {
      textValue = formatCentsAsUsd(value)
      setValue()
    }
  }
</script>

<input
  type="text"
  id={id || name}
  {disabled}
  bind:value={textValue}
  on:input={setValue}
  class="{className} amount-input pr-4"
  on:blur={formatValue}
  data-role={dataRole} />
